export enum EVENTS_TYPES {
    strip_loaded = 'strip_loaded',
    strip_unit_clicked = 'strip_unit_clicked',
    strip_seen = 'strip_seen',
  }